import { render, staticRenderFns } from "./StickerContainer.vue?vue&type=template&id=305e812c&scoped=true"
import script from "./StickerContainer.vue?vue&type=script&lang=js"
export * from "./StickerContainer.vue?vue&type=script&lang=js"
import style0 from "./StickerContainer.vue?vue&type=style&index=0&id=305e812c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e812c",
  null
  
)

export default component.exports